{
  "acceptedFileFormats": "Kun .docx-, .pdf- og .txt-filer accepteres.",
  "actionCompetenceGroup": "Handlingskompetencegruppe",
  "actionDeadline": "Handlingsdeadline",
  "actionDescription": "Handlingsbeskrivelse",
  "actionDuration": "Handlingsvarighed",
  "actionEarliestStart": "Tidligste handlingsstart",
  "actionName": "Handlingsnavn",
  "actions": "Handlinger",
  "actionsAndProjects": "Handlinger & projekter",
  "actionsColon": "Handlinger: ",
  "actionsPerformerConstraints": "Performer begrænsninger for handlinger",
  "add": "Tilføj",
  "addAdmin": "Tilføj administrator",
  "addAdminTitle": "Tilføj administrator",
  "addAnalyses": "Tilføj analyser",
  "addAnalysis": "Tilføj analyse",
  "addAnalysisGroup": "Tilføj en analysegruppe",
  "addChatbot": "Tilføj chatbot",
  "addCompetenceGroup": "Tilføj kompetencegruppe",
  "addConstraint": "Tilføj begrænsning",
  "addGreyTask": "Tilføj en grå opgave",
  "addInstrument": "Tilføj et instrument",
  "addItemPlaceholder": "Tilføj {{item}}...",
  "addLocation": "Tilføj lokation",
  "addMaintenance": "Tilføj vedligehold",
  "addMember": "Tilføj medlem",
  "addNewBundle": "Tilføj nyt bundt",
  "addNewMaintenanceFor": "Tilføj nyt vedligehold for {{assetName}}",
  "addNewTask": "Tilføj en ny opgave",
  "addOffsite": "Tilføj OFFSITE",
  "addProjectGroup": "Tilføj en projektgruppe",
  "addProjectTemplate": "Tilføj projektskabelon",
  "addRepository": "Tilføj repository",
  "addRow": "Tilføj række",
  "addSample": "Tilføj prøve",
  "addSamples": "Tilføj prøver",
  "addTeam": "Tilføj hold",
  "additionalInformation": "Yderligere information",
  "administrators": "Administratorer",
  "advanced": "Avanceret",
  "allFilesProcessed": "Alle uploadede filer er blevet behandlet",
  "allowMembersMoveOthersOperationalTasks": "Tillad medlemmer at flytte andres operationelle opgaver",
  "allowedCompetenceGroups": "Tilladte kompetencegrupper",
  "allowedInstruments": "Tilladte instrumenter",
  "amountOfSamples": "Antal prøver: {{count}}",
  "analyses": "Analyser",
  "analysesRelatedTo": "Analyser relateret til {{product}}",
  "analysis": "Analyse",
  "analysisAndSampleDone": "Analysen og prøven er færdig",
  "analysisDefinition": "analysedefinition",
  "analysisDesignTool": "Analysedesignværktøj",
  "analysisDone": "Analysen er færdig",
  "analysisDraft": "Analyse KLADDE",
  "analysisGroup": "Analysegruppe",
  "analysisGroupName": "Analysegruppenavn",
  "analysisIsFlagged": "Analyse er markeret",
  "analysisMustContainTaskDefinition": "Analysen skal indeholde en opgavedefinition",
  "analysisName": "Analysenavn",
  "analysisNameMustBeUnique": "Analysenavn skal være unikt",
  "analysisNotPlanned": "Denne analyse er ikke planlagt",
  "analysisPlanned": "Analysen er planlagt",
  "analysisTaskBundle": "Analyseopgavebundt {{index}}",
  "cdmoTargetedBundle": "Saml opgaver efter analysenavn",
  "analysisTaskTimePerformerSamples": "Analyseopgave - Tid, Performers, Antal prøver",
  "analysisTasks": "analyseopgaver",
  "analysisTasksToBundle": "Analyseopgaver til bundt",
  "analysisTimePercentage": "Procentdel af analysetid i forhold til samlet tid (A2T)",
  "anywhere": "Hvor som helst",
  "apiToken": "API token",
  "archiveMember": "Arkivér medlem",
  "archived": "arkiveret",
  "areYouSureConnection": "Er du sikker på, at du vil have denne forbindelse?",
  "areYouSureConnectionMode": "Er du sikker på, at du vil skifte til \"med forbindelse\"-tilstand? Dette fjerner alle nuværende forbindelser",
  "areYouSureDeleteAdmin": "Er du sikker på, at du vil slette denne administrator?",
  "areYouSureDiscardSimulation": "Er du sikker på, at du vil kassere ændringerne foretaget i simuleringstilstand?",
  "areYouSurePublishSimulation": "Er du sikker på, at du vil publicere ændringerne foretaget i simuleringstilstand?",
  "areYouSureReset": "Er du sikker på, at du vil nulstille? Dette fjerner alle noder.",
  "areYouSureUnplanAllFutureActions": "Er du sikker på, at du vil fjerne alle fremtidige handlinger i dette projekt fra planen?",
  "areYouSureWantToExit": "Er du sikker på, at du vil afslutte?",
  "arrival": "Ankomst",
  "assetAddedOrRemoved": "Instrument er blevet tilføjet eller fjernet",
  "assetRequirementsForAsset": "Instrumentkrav for instrument {{index}}",
  "assets": "Instrumenter",
  "atLeast1LowercaseLetter": "mindst 1 lille bogstav",
  "atLeast1Number": "mindst 1 tal",
  "atLeast1UppercaseLetter": "mindst 1 stort bogstav",
  "atLeast8Characters": "mindst 8 tegn",
  "automaticImportConversionSheet": "Automatisk {{type}} importkonverteringsark",
  "automaticSheetConfiguration": "Automatisk ark-konfiguration",
  "availability": "Tilgængelighed",
  "availableTimeOneWeek": "Tilgængelig tid én uge: ",
  "avgAnalysisDuration": "Gennemsnitlig analysevarighed: ",
  "avgSampleBatchInterval": "Gennemsnitligt prøvebatchinterval: ",
  "avgSamplesAllocated": "Gennemsnitligt antal allokerede prøver: ",
  "backlog": "Backlog",
  "booked": "Booket",
  "bookedBy": "Booket af",
  "byCompetenceGroup": "Efter kompetencegruppe",
  "byDeadline": "Efter deadline",
  "byGroup": "Efter gruppe",
  "byText": "Efter tekst",
  "canBePerformedAnywhere": "Kan udføres hvor som helst",
  "canOnlyBePerformedOnSite": "Kan kun udføres på stedet",
  "cancel": "Annuller",
  "cancelChanges": "Annuller ændringer",
  "cannotUnlockStartedTasks": "Du kan ikke låse op, da en eller flere opgaver er startet/sat på pause/afsluttet",
  "changeLogs": "Ændringslog",
  "changesHaveBeenMade": "Der er foretaget ændringer, genindlæs for nye data",
  "chatbotGreeting": "Hej, jeg er din AI CHATBOT, specialiseret i Plannertech & Librarian hjælpedokumentation og de datarepositorier du har importeret.\nDu kan også altid kontakte vores menneskelige support på pt@arnvind.com fra 9-16 CET.\nHvordan kan jeg hjælpe dig? :-)",
  "chatbotName": "Chatbot-navn",
  "chatbotPlaceholder": "Skriv en kort beskrivelse af, hvordan chatbotten skal opføre sig.",
  "chatbots": "Chatbotter",
  "chattingWith": "Chatter med {{name}}",
  "chooseAction": "Vælg handling",
  "chooseTask": "Vælg opgave",
  "chooseWhatToAdd": "Vælg hvad der skal tilføjes",
  "cleanUp": "Ryd op",
  "clear": "Ryd",
  "clearConversation": "Ryd samtalen",
  "clearDates": "Ryd datoer",
  "clearTable": "Ryd tabel",
  "clickToSelectOtherFiles": "Klik for at vælge andre filer",
  "close": "Luk",
  "closeMessage": "luk besked",
  "closePanel": "Luk panel",
  "collaborator": "Samarbejdspartner",
  "collaborators": "Samarbejdspartnere",
  "domain": "Domæne",
  "color": "Farve",
  "columnName": "Kolonnenavn",
  "companyWideChatbot": "Virksomhedsdækkende chatbot",
  "competenceAndInstrumentConstraints": "Kompetence- og instrumentbegrænsninger",
  "competenceGroup": "Kompetencegruppe",
  "competenceGroupNameExists": "Der findes allerede en kompetencegruppe med det navn",
  "competenceGroups": "Kompetencegrupper",
  "competenceGroupsColon": "Kompetencegrupper: ",
  "configuration": "Konfiguration",
  "confirm": "Bekræft",
  "confirmArchivalOfMember": "Bekræft arkivering af medlem: {{initials}}",
  "confirmClearTable": "Er du sikker på, at du vil rydde tabellen?",
  "confirmDeleteAllData": "Ved bekræftelse slettes alle {{type}}-data. Det kan ikke fortrydes, selv i simuleringstilstand.",
  "confirmDeleteAllUnplannedProjects": "Ved bekræftelse slettes alle projekter uden handlinger på planen",
  "confirmDeleteAllUnplannedSamples": "Ved bekræftelse slettes alle prøver uden handlinger på planen",
  "confirmDeleteCompetenceGroup": "Bekræft sletning af kompetencegruppe:",
  "confirmDeleteInstrument": "Er du sikker på, at du vil slette instrument: {{name}}?",
  "confirmDeleteMaintenance": "Er du sikker på, at du vil slette dette vedligehold?",
  "confirmDeleteSample": "Er du sikker på, at du vil slette denne ikke-planlagte prøve?",
  "confirmDeleteSampleInfo": "Ved bekræftelse slettes den valgte prøve permanent",
  "confirmDeletion": "Bekræft sletning",
  "confirmFailSamples": "Er du sikker på, at du vil fejle de valgte prøver?",
  "confirmFailSamplesInfo": "Ved bekræftelse fejles de valgte prøver. En kopi placeres i menuen for ikke-planlagte analyser",
  "confirmFailSamplesQuestion": "Er du sikker på, at du vil fejle de valgte prøver?",
  "confirmShowPlannedSamplesInfo": "Ved bekræftelse vises planlagte prøver",
  "confirmShowPlannedSamplesQuestion": "Er du sikker på, at du vil vise planlagte prøver?",
  "confirmSortByTime": "Er du sikker på, at du vil sortere efter tid",
  "confirmUnplanAllFutureActions": "Er du sikker på, at du vil afplanlægge alle fremtidige handlinger i dette projekt?",
  "confirmUnplanAllQuestion": "Er du sikker på, at du vil afplanlægge alle {{itemType}}?",
  "confirmUnplanSamplesInfo": "Ved bekræftelse afplanlægges de valgte prøver. De placeres i menuen for ikke-planlagte analyser",
  "confirmUnplanSamplesQuestion": "Er du sikker på, at du vil afplanlægge de valgte prøver?",
  "connectionCalculatedInWorkdays": "Forbindelse beregnet i arbejdsdage",
  "connectionCount": "Antal forbindelser",
  "connections": "Forbindelser",
  "connectionsAdvancedWarning": "(Brug af forbindelser med deadline eller tidligste start på handlinger er for avancerede brugere)",
  "connectionsPerformersOnly": "Forbindelser gælder kun for performers — påvirker ikke instrumentallokering",
  "contactArnvindSupport": "Kontakt venligst Arnvind support på pt@arnvind.com",
  "conversionSheet": "Konverteringsark",
  "copyToClipboard": "kopiér til udklipsholder",
  "country": "Land",
  "create": "Opret",
  "createANewColumn": "Opret en ny kolonne",
  "createAction": "Opret handling",
  "createChatbot": "Opret chatbot",
  "createEditChatbots": "Opret/redigér chatbotter",
  "createEditRepositories": "Opret/redigér repositories",
  "createNewColumn": "Opret en ny kolonne",
  "createNewProject": "Opret nyt projekt",
  "createSingleAction": "Opret enkelt handling",
  "createStage": "Opret fase",
  "createStandardAction": "Opret standardhandling",
  "currentlyProcessingRepository": "Behandler dette repository i øjeblikket",
  "daily": "Daglig",
  "date": "Dato",
  "dateUnavailable": "Dato ikke tilgængelig",
  "day": "dag",
  "dayS": "dag(e)",
  "days": "dag(e)",
  "daysBeforeExpirationWarning": "Dage før udløb for at vise advarsel",
  "daysBetweenRecurrences": "Dage mellem gentagelser",
  "deadline": "Deadline",
  "deadlineColon": "Deadline: ",
  "deadlineDate": "Deadlinedato",
  "deadlineMustBeLaterThanEarliestStart": "Deadline skal være senere end eller lig med tidligste start",
  "deadlineTime": "Deadlinetid",
  "defaultChatbot": "Standard-chatbot",
  "delete": "Slet",
  "deleteAllTypeTestData": "Slet alle {{type}} testdata",
  "deleteAllUnplannedProjects": "Slet alle ikke-planlagte projekter",
  "deleteAllUnplannedSamples": "Slet alle ikke-planlagte prøver",
  "deleteColumn": "Slet kolonne",
  "deleteCompetenceGroup": "Slet kompetencegruppe",
  "deleteCompetenceGroupWarning": "Sletning vil efterlade opgaver i følgende analyser uden en kompetencegruppe. Sørg for erstatning inden sletning.",
  "deleteConstraint": "Slet begrænsning",
  "deleteData": "Slet data",
  "deleteInstrument": "Slet instrument",
  "deleteInstrumentWarning": "Det vil også blive slettet for andre hold på denne lokation.",
  "deleteProjects": "Slet projekter",
  "deleteSample": "Slet prøve",
  "deleteSamples": "Slet prøver",
  "deleteThisRow": "Slet denne række",
  "description": "Beskrivelse",
  "designTool": "Designværktøj",
  "done": "Færdig",
  "draft": "kladde",
  "dragAndDropFiles": "Træk og slip filer her, eller klik for at vælge filer",
  "dragAndDropFolders": "Træk og slip mapper her, eller klik for at vælge specifikke filer",
  "dropFilesHere": "Slip filer her",
  "dropFoldersHere": "Slip mapperne her...",
  "duplicate": "Dupliker",
  "durationHHMM": "Varighed (TT:MM)",
  "earliestStart": "Tidligste start",
  "edit": "Rediger",
  "editAction": "Rediger handling",
  "editAdmin": "Rediger administrator",
  "editAnalysisGroup": "Rediger analysegruppe",
  "editAnalysisTask": "Rediger analyseopgave",
  "editChatbot": "Rediger chatbot",
  "editCompetenceGroup": "Rediger kompetencegruppe",
  "editConnectionFromTo": "Rediger forbindelse fra {{from}} til {{to}}",
  "editConversation": "Rediger samtale",
  "editGroup": "Rediger gruppe",
  "editInstrument": "Rediger instrument",
  "editItem": "Rediger {{item}}",
  "editLocationName": "Rediger lokationsnavn",
  "editMaintenanceFor": "Rediger {{name}} for {{assetName}}",
  "editMember": "Rediger medlem",
  "editOffsite": "Rediger OFFSITE",
  "editProject": "Rediger projekt",
  "editProjectGroup": "Rediger projektgruppe",
  "editProjectTemplate": "Rediger projektskabelon",
  "editProjectTemplateDraft": "Rediger projektskabelon KLADDE",
  "editRepository": "Rediger repository",
  "editSampleName": "Rediger prøve: {{name}}",
  "editSheet": "Rediger ark {{name}}",
  "editStandardAction": "Rediger standardhandling",
  "editTask": "Rediger opgave",
  "editTeam": "Rediger hold",
  "edited": "Redigeret",
  "email": "e-mail",
  "emailCannotContainDoubleDots": "Email må ikke indeholde '..'",
  "emailLabel": "Email",
  "endDate": "Slutdato",
  "enterSimulationMode": "Gå i simuleringstilstand",
  "errors": "Fejl",
  "errorsProcessingRepository": "Der opstod fejl under behandling af dette repository",
  "estimatedWorkloadOneWeek": "Estimeret arbejdsbyrde én uge: ",
  "exclusive": "Eksklusiv",
  "exclusiveSampleIndicator": "* Angiver en eksklusiv prøve",
  "exitSimulation": "AFSLUT SIMULERING",
  "exitSimulationMode": "Afslut simuleringstilstand",
  "expand": "Udvid",
  "exportToExcel": "Eksportér til Excel",
  "fail": "Fejlmarkér",
  "failSample": "Fejlmarkér prøve",
  "failSelected": "Fejlmarkér valgte",
  "failedLoading": "Indlæsning mislykkedes: {{members}}",
  "failedToCreateMaintenance": "Kunne ikke oprette vedligehold \"{{name}}\"",
  "failedToDeleteMaintenance": "Kunne ikke slette vedligehold \"{{name}}\"",
  "failedToMarkMaintenanceAsCompleted": "Kunne ikke markere vedligehold \"{{name}}\" som afsluttet",
  "failedToUpdateMaintenance": "Kunne ikke opdatere vedligehold \"{{name}}\"",
  "failedUploads": "Mislykkede uploads",
  "fileUpload": "Filupload",
  "fileUploadError": "Der opstod en fejl under filupload",
  "filenameLabel": "Filnavn: ",
  "filesUploadedSuccessfully": "Filer uploadet succesfuldt",
  "fillIn": "Udfyld",
  "fillInIgnoreOverbooking": "Udfyld ignorer overbooking",
  "filter": "Filter",
  "filterByName": "Filtrer efter navn",
  "filterBySampleName": "Filtrer efter prøvenavn",
  "filterBySampleProductName": "Filtrer efter prøve-/produktnavn",
  "filterByText": "Filtrer efter tekst",
  "finished": "Afsluttet",
  "flag": "Markér",
  "flagSample": "Markér prøve",
  "followingErrorsWhileImporting": "Følgende fejl under import:",
  "free": "Ledig",
  "from": "Fra",
  "fromDate": "Fra dato",
  "fromTime": "Fra tid (TT:MM)",
  "fromTimeHH": "Fra tid (HH)",
  "fromTimeHHMM": "Fra tid (HH:MM)",
  "futureAnalysisTaskCantBe": "En fremtidig analyseopgave kan ikke være {{state}}",
  "generate": "Generer",
  "globalChatbot": "Global chatbot",
  "goBack": "Gå tilbage",
  "goBackToChat": "Gå tilbage til chat",
  "greyTaskTimePercentage": "Procentdel af grå opgavetid i forhold til samlet tid (G2T)",
  "groupMembers": "Gruppemedlemmer",
  "groupName": "Gruppenavn",
  "help": "Hjælp",
  "helpBackToApp": "Tilbage til appen",
  "helpHome": "Hjælp forside",
  "helpPageNotFound": "Hjælpeside ikke fundet",
  "helpSearch": "Søg i hjælp",
  "helpAppTitle": "Plannertech Hjælp",
  "hidden": "Skjult",
  "hideMore": "Skjul mere",
  "highestPriority": "1 er højeste prioritet",
  "history": "Historik",
  "home": "Hjem",
  "hour": "time",
  "iCalendarOutlookIntegration": "iCalendar / Outlook Integration",
  "iap": "IAP",
  "ignoreAllGreytasks": "Ignorer alle grå opgaver",
  "ignoredByIap": "Ignoreret af IAP",
  "includingToday": "Inkl. i dag",
  "importedTask": "Importeret opgave",
  "busyOnAnotherTeam": "Optaget på et andet hold",
  "includeDoneSamples": "Inkluder afsluttede prøver",
  "includeOverdue": "Inkluder forfaldne",
  "includeToday": "Inkluder i dag",
  "iapIncludeTodayWarningIAP": "Advarsel: IAP og Inkluder i dag – opgaver planlagt tidligere i dag kan også flyttes, medmindre de er låst!",
  "iapIncludeTodayWarningFillIn": "Advarsel: Udfyld og Inkluder i dag – opgaver planlagt tidligere i dag kan også få tildelt nye prøver!",
  "initials": "Initialer",
  "inputLastMonth": "Input forrige måned",
  "inputThisMonth": "Input denne måned",
  "instrument": "Instrument",
  "instrumentConstraints": "Instrumentbegrænsninger",
  "instrumentLog": "Instrumentlog",
  "instrumentName": "Instrumentnavn",
  "instrumentOffset": "Instrument offset (TT:MM)",
  "instrumentOverbooking": "Instrumentoverbooking",
  "instrumentPerSampleDuration": "Instrument varighed pr. prøve (TT:MM:SS)",
  "instrumentSetup": "Instrumentopsætning {{name}}",
  "instrumentSetuptime": "Instrument opsætningstid (TT:MM)",
  "instrumentTime": "Instrumenttid",
  "instrumentView": "Instrumentvisning",
  "instruments": "Instrumenter",
  "instrumentsWithExpiredMaintenance": "Der er instrumenter med udløbet vedligehold",
  "instrumentsWithMaintenanceReminders": "Der er instrumenter med vedligeholdspåmindelser",
  "integration": "Integration",
  "invalidDate": "Ugyldig dato",
  "invalidOutlookLink": "Ugyldigt iCalendar / Outlook-link",
  "isInSimulationMode": "{{initials}} er i simuleringstilstand",
  "isSimulating": "{{initials}} simulerer...",
  "keepExistingConnections": "Behold eksisterende forbindelser",
  "labelAlreadyLoaded": "Allerede indlæst: {{count}}",
  "labelCreated": "Oprettet: {{count}}",
  "labelDeleted": "Slettet: {{count}}",
  "labelDeletedOrFinished": "Slettet eller markeret som afsluttet: {{count}}",
  "labelDoneDeleted": "Færdig/Slettet: {{count}}",
  "labelUpdatedInformation": "Opdateret information: {{count}}",
  "lastErrorLog": "Seneste fejllog",
  "lastWeek": "Sidste uge",
  "latestArrival": "Seneste ankomst",
  "leadTimesInWorkDays": "Leveringstider i arbejdsdage",
  "leaveEmptyIfNotUsed": "(lad være tomt hvis ikke brugt)",
  "leaveEmptyIfNotUsedDefault": "(lad være tomt hvis ikke brugt, standard={{defaultValue}})",
  "loadFromTemplate": "Indlæs fra skabelon",
  "loading": "INDLÆSER",
  "loadingEllipsis": "Indlæser...",
  "loadingSamples": "Indlæser prøver",
  "loadingSheet": "Indlæser ark",
  "loadingSheets": "Indlæser ark",
  "location": "Lokation",
  "locationColon": "Lokation: {{name}}",
  "locationName": "Lokationsnavn",
  "lockItemType": "Lås {{itemType}}",
  "lockSamples": "Lås prøver",
  "lockUnlockSamplesLabel": "Lås/op-lås prøver:",
  "locks": "Låser",
  "locksAllFutureAnalysisTasks": "Låser alle fremtidige planlagte analyseopgaver",
  "locksAllFutureProjectActions": "Låser alle fremtidige planlagte projekthandlinger",
  "login": "Log ind",
  "logout": "Log ud",
  "maintenanceCreatedSuccessfully": "Vedligehold \"{{name}}\" er oprettet",
  "maintenanceDeletedSuccessfully": "Vedligehold \"{{name}}\" er slettet",
  "maintenanceExpired": "Vedligehold udløbet",
  "maintenanceExpiresInDays": "Vedligehold udløber om færre end {{days}} dage",
  "maintenanceMarkedAsCompleted": "Vedligehold \"{{name}}\" markeret som afsluttet",
  "maintenanceName": "Vedligeholdsnåvn",
  "maintenanceUpdatedSuccessfully": "Vedligehold \"{{name}}\" er opdateret",
  "mandatoryIfRecurrenceUsed": "(påkrævet hvis gentagelse bruges)",
  "manualSample": "Manuel prøve",
  "manualSheetConfiguration": "Manuel ark-konfiguration",
  "markAsDone": "Marker som færdig",
  "maxSampleCount": "Maks. antal prøver",
  "maxSampleCountLabel": "Maks. antal prøver: ",
  "maxTimeBetweenActions": "Maksimum tid mellem handlinger (DD:TT:MM)",
  "maxTimeBetweenTasks": "Maksimum tid mellem opgaver (DD:TT:MM)",
  "member": "Medlem",
  "memberHasEnabledICalendarOutlookIntegration": "Medlem har aktiveret iCalendar / Outlook-integration",
  "memberHasEnabledOutlook": "Medlem har aktiveret iCalendar / Outlook-integration",
  "memberPermissions": "Medlemstilladelser",
  "memberPlan": "Medlemsplan",
  "memberTime": "Medlemstid",
  "membersGoDirectlyToMemberPlan": "Medlemmer går direkte til medlemsplanen",
  "message": "Besked",
  "metric": "Metrik",
  "minSampleCount": "Min. antal prøver",
  "minSampleMustBeLowerThanMax": "Min. antal prøver skal være lavere end maks. antal prøver",
  "minTimeBetweenActions": "Minimum tid mellem handlinger (DD:TT:MM)",
  "minTimeBetweenTasks": "Minimum tid mellem opgaver (DD:TT:MM)",
  "minTimeMustBeSmallerThanMax": "Minimum tid skal være kortere end maksimum tid",
  "minimumDuration": "Minimumsvarighed: {{time}}",
  "minute": "minut",
  "missingPasswordRequirements": "Manglende adgangskravekrav: {{requirements}}",
  "months": "Måneder",
  "movedBy": "Flyttet af",
  "movedFrom": "Flyttet fra",
  "movedTo": "Flyttet til",
  "mustBeIcsLink": "Skal være et .ics-link",
  "name": "Navn",
  "namePerformer": "{{name}} performer",
  "nameTooLongTitle": "Navn for langt (maks. 100 tegn)",
  "newAnalysisTaskBundle": "Ny analyseopgavebundt",
  "newChat": "Ny chat",
  "newInstrument": "Nyt instrument",
  "newProject": "Nyt projekt",
  "newProjectTemplateDraft": "Ny projektskabelon KLADDE",
  "newStart": "Ny start",
  "nextDay": "Næste dag",
  "nextWeek": "Næste uge",
  "no": "Nej",
  "noAnalysesForProduct": "Ingen analyser fundet for dette produkt.",
  "noAssetsFound": "Ingen instrumenter fundet",
  "noChanges": "Ingen ændringer",
  "noChatbotSelected": "Ingen chatbot valgt",
  "noDataFound": "Ingen data fundet",
  "noErrorsToDisplay": "Ingen fejl at vise.",
  "noGroup": "Ingen gruppe",
  "noMembersLoaded": "Ingen medlemmer blev indlæst.",
  "noOfRecurrences": "Antal gentagelser",
  "noReferencesAvailable": "Ingen referencer tilgængelige.",
  "noSamples": "Ingen prøver",
  "noSamplesAvailable": "Ingen prøver tilgængelige",
  "noSearchResults": "Ingen søgeresultater",
  "noTimeLimitUnlessSpecified": "Ingen tidsgrænse medmindre specificeret",
  "none": "Ingen",
  "default": "Standard",
  "notAvailable": "I/T",
  "notEnoughRoomForDuration": "Ikke nok plads til varigheden",
  "notStarted": "Ikke startet",
  "numberOfObservations": "Antal observationer",
  "numberOfRecurrences": "Antal gentagelser",
  "numericInputBetweenTimeRange": "Indtast venligst et tal mellem 00:00 og 23:59",
  "offsiteCalendar": "OFFSITE kalender",
  "ok": "OK",
  "oldInstrument": "Gammelt instrument",
  "oldStart": "Gammel start",
  "onlyAdvancedUsersInfo": "Kun avancerede brugere benytter både tidligste start og forbindelser",
  "onsite": "På stedet",
  "openReferences": "Åbn referencer",
  "operationalGreyTaskTimePercentage": "Procentdel af operationel grå opgavetid i forhold til samlet tid (OG2T)",
  "operationalTask": "Operationel opgave",
  "otherPlannerSimulating": "{{initials}} er i simuleringstilstand",
  "outlookLinkLabel": "iCalendar / Outlook-link",
  "outputLastMonth": "Output forrige måned",
  "outputThisMonth": "Output denne måned",
  "parentColumn": "Overordnet kolonne",
  "password": "Adgangskode",
  "paused": "Sat på pause",
  "peopleSetup": "Personaleopsætning",
  "perSampleDuration": "Varighed pr. prøve (TT:MM:SS)",
  "perSampleDurationForPeopleSetup": "Varighed pr. prøve for personaleopsætning",
  "performerConstraintsCount": "Antal performer begrænsninger",
  "performerConstraintsLabel": "Performer Begrænsninger",
  "permanentApiToken": "Permanent API-token",
  "permanentApiTokenDescription": "Dette er et permanent API-token, som giver adgang til dit hold via vores API. Kopiér og gem det på et sikkert sted.",
  "pinConversation": "Fastgør samtale",
  "planned": "Planlagt",
  "planner": "Planner",
  "plannertechLanguage": "Plannertech-sprog",
  "plannertechVariable": "Plannertech-variabel",
  "pleaseChooseColor": "Vælg venligst en farve til analysen",
  "pleaseFillOutAnalysisName": "Udfyld venligst analysenavnet",
  "pleaseFillOutRequiredTaskParams": "Udfyld venligst de påkrævede opgaveparametre",
  "pleaseGiveEmptyOrFullInput": "Indtast venligst tomt eller fuldt input",
  "pleaseGiveNumericInput": "Indtast venligst et tal",
  "pleaseInputValidDate": "Indtast venligst en gyldig dato",
  "pleaseSelectAtLeastOneItem": "Vælg venligst mindst ét element",
  "pleaseSelectColor": "Vælg venligst en farve",
  "pleaseSelectFirstDay": "Vælg venligst den første dag.",
  "pleaseSelectLastDay": "Vælg venligst den sidste dag.",
  "pleaseSelectTimezone": "Vælg venligst en tidszone",
  "previousDay": "Forrige dag",
  "primary": "Primær",
  "primaryInstrument": "Primært instrument",
  "prioritizeByDeadline": "Prioriter IAP efter deadline",
  "prioritizeByPriority": "Prioriter IAP efter prioritetsnummer",
  "priority": "Prioritet",
  "priorityHigh": "(Høj)",
  "priorityLow": "(Lav)",
  "priorityMedium": "(Medium)",
  "process": "Behandl",
  "processed": "Behandlet",
  "processing": "Behandler...",
  "processingInProgress": "Behandler",
  "productName": "Produktnavn",
  "project": "Projekt",
  "projectActions": "projekthandlinger",
  "projectBatchNumber": "Projektbatchnummer",
  "projectDeadline": "Projektdeadline",
  "projectDescription": "Projektbeskrivelse",
  "projectEarliestStart": "Tidligste projektstart",
  "projectGroup": "Projektgruppe",
  "projectGroupName": "Projektgruppenavn",
  "projectImport": "Projektimport",
  "projectImportVariable": "Projektimportvariabel",
  "projectMaterialDescription": "Projektmaterialebeskrivelse",
  "projectMaterialNumber": "Projektmaterialenummer",
  "projectName": "Projektnavn",
  "projectPriority": "Projektprioritet",
  "projectReleaseDate": "Projektfrigivelsesdato",
  "projectSupplierName": "Projektleverandørnavn",
  "projectSupplierNumber": "Projektleverandørnummer",
  "projectTemplate": "Projektskabelon",
  "projectTemplates": "Projektskabeloner",
  "projectTimePercentage": "Procentdel af projekttid i forhold til samlet tid (P2T)",
  "projectView": "Projektvisning",
  "projects": "Projekter",
  "projectsAndActions": "Projekter & handlinger",
  "promptPrefix": "Prompt-præfiks",
  "promptTooLongTitle": "Prompt for lang (maks. 1200 tegn)",
  "publish": "PUBLICER",
  "publishSimulationChanges": "Publicer ændringer fra simuleringstilstand",
  "qcLibrarian": "QC Librarian",
  "qcLibrarianTitle": "QC Librarian 3.8",
  "recur": "Gentag",
  "recurEvery": "Gentag hver",
  "recurrence": "Gentagelse",
  "reduce": "Reducer",
  "references": "Referencer",
  "rejectedFileTypes": "Afviste filtyper",
  "rejectedFilesIncompatible": "Følgende filer blev afvist pga. inkompatible formater",
  "reminderDaysBeforeEndDate": "Påmindelse (dage inden slutdato)",
  "remove": "Fjern",
  "removeAnalysisFromProduct": "Fjern {{name}} fra dette produkt",
  "removeAsset": "Fjern instrument",
  "removeEverything": "Fjern alt",
  "removeInstrument": "Fjern instrument",
  "reportGenerator": "Rapportgenerator",
  "reports": "Rapporter",
  "repositories": "Repositoryer",
  "repositoryCurrentlyProcessing": "Repositoryet behandler i øjeblikket filerne. Opdatér siden for at se fremdriften",
  "repositoryHasUnprocessedFiles": "Dette repository har ubehandlede filer",
  "repositoryIsProcessed": "Dette repository er behandlet",
  "repositoryName": "Repository-navn",
  "reset": "Nulstil",
  "role": "Rolle",
  "row": "Række",
  "rowNumber": " række {{row}}",
  "runIAP": "Kør IAP",
  "runningIAP": "Kører IAP",
  "sampleAnalysisName": "Analysenavn for prøve",
  "sampleBatchNumber": "Prøvebatchnummer",
  "sampleHighestPriority": "Prøven har højeste prioritet",
  "sampleId": "Prøve-ID",
  "sampleIdWithValue": "Prøve-ID: {{id}}",
  "sampleImport": "Prøveimport",
  "sampleImportVariable": "Prøveimportvariabel",
  "sampleInProgressOnDoneAnalysis": "Prøve i gang på afsluttet analyse",
  "sampleIsDone": "Prøven er færdig",
  "sampleLog": "Prøvelog",
  "sampleLowestPriority": "Prøven har laveste prioritet",
  "sampleMaterialNumber": "Prøvematerialenummer",
  "sampleName": "Prøvenavn",
  "sampleObservation": "Prøveobservation",
  "sampleObservations": "Prøveobservationer",
  "samplePercentage": "Prøveprocent",
  "sampleProductDescription": "Prøveproduktbeskrivelse",
  "sampleReceivedDate": "Prøvemodtagelsesdato",
  "sampleStatus": "Prøvestatus",
  "sampleView": "Prøvevisning",
  "samples": "Prøver",
  "samplesWithName": "Prøver med navnet {{name}}",
  "samplesWithoutProduct": "Prøver uden produkt",
  "save": "Gem",
  "saveAs": "Gem som",
  "saveAsDraft": "Gem som {{type}} KLADDE",
  "saveAsNew": "Gem som ny",
  "saveAsNewAnalysis": "Gem som ny analyse",
  "saveAsNewTemplate": "Gem som ny skabelon",
  "saveAsType": "Gem som {{type}}",
  "scrollToTop": "Rul til toppen",
  "scrumView": "Scrum-visning",
  "scrumViewOrdering": "Scrum-visningsrækkefølge",
  "searchBySampleName": "Søg efter prøvenavn...",
  "searchCountry": "Søg land",
  "seats": "Sæder",
  "second": "sekund",
  "secondaryInstrumentMustHaveAllowedInstrument": "Sekundært instrumentopsætning skal have mindst ét tilladt instrument",
  "selectAll": "Vælg alle",
  "selectChatbot": "Vælg chatbot",
  "selectDefaultChatbot": "Vælg standard-chatbot",
  "selectEntireDay": "Vælg hele dagen",
  "selectEntireWorkday": "Vælg hele arbejdsdagen",
  "selectLocation": "Vælg placering...",
  "selectSamples": "Vælg prøver",
  "selectState": "Vælg tilstand...",
  "selectTimezone": "Vælg tidszone...",
  "selectType": "Vælg type",
  "selectedFilesReadyForSubmit": "Valgte filer/mapper klar til indsendelse:",
  "selectedProduct": "Valgt produkt",
  "setPlannedValues": "Sæt planlagte værdier",
  "settings": "Indstillinger",
  "settingsForQcLibrarian": "Indstillinger for QC Librarian",
  "setupTimeForPeopleSetup": "Opsætningstid for personaleopsætning",
  "setuptime": "Opsætningstid (TT:MM)",
  "sheetName": "Arknavn",
  "sheetNameLabel": "Arknavn",
  "sheetType": "Arktype",
  "shouldBeEqualTo": "skal være lig med",
  "shouldNotBeEqualTo": "skal ikke være lig med",
  "showAnalyses": "Vis analyser",
  "showErrors": "Vis fejl",
  "showLastErrorLog": "Vis seneste fejllog",
  "showLibrarian": "Vis Librarian",
  "showLog": "Vis log",
  "showMore": "Vis mere",
  "showOnPlan": "Vis på plan",
  "showProjects": "Vis projekter",
  "shown": "Synlig",
  "simulationMode": "Simuleringstilstand",
  "simulationModeLogoutWarning": "Du er i simuleringstilstand. Hvis du logger ud, vil ændringerne blive kasseret!",
  "simulationModeOccupied": "SIMULERINGSTILSTAND OPTAGET",
  "simulationModeUpper": "SIMULERINGSTILSTAND",
  "somethingWentWrong": "Noget gik galt",
  "sortByProduct": "Sorter efter produkt",
  "sortByTime": "Sorter efter tid",
  "sortByTimeDescription": "Sorterer backlog og To Do-handlinger efter deadline, og planlagte og afsluttede efter starttidspunkt",
  "speechToTextLanguage": "Sprog til tale-til-tekst",
  "spreadsheetColumnName": "Regnearkskolonnenavn",
  "stage": "Fase",
  "standardActions": "Standardhandlinger",
  "start": "Start",
  "startDate": "Startdato",
  "startDateCheckboxInfo": "Når markeret, flyttes projektdeadline, handlingsdeadline og handlingsstart relativt til projektstart",
  "startEndDate": "Start-/slutdato",
  "startProcessingInfo": "Dette starter behandlingen af repositoryet. Det kan tage lidt tid afhængigt af repositoryets størrelse",
  "startRecurrence": "Start gentagelse",
  "startTime": "Starttidspunkt",
  "started": "Startet",
  "state": "Tilstand",
  "status": "Status",
  "submit": "Indsend",
  "successfullyLoaded": "Indlæst: {{members}}",
  "successfullyUploadedFiles": "Filer uploadet succesfuldt",
  "systemPrompt": "Systemprompt",
  "taskBelongsToTeam": "Opgave tilhører hold: {{team}}",
  "taskCount": "Antal opgaver",
  "taskDesignTool": "Opgavedesignværktøj",
  "taskLog": "Opgavelog",
  "taskName": "Opgavenavn",
  "taskPerformerConstraints": "Performer begrænsninger for opgave",
  "tasks": "Opgaver",
  "team": "Team",
  "teamChatbot": "Hold-chatbot",
  "teamLabel": "Team: {{name}}",
  "teamMember": "Holdmedlem",
  "teamName": "Holdnavn",
  "teamPlan": "Holdplan",
  "teamUsageTitle": "{{name}} forbrug",
  "teams": "Hold",
  "templateIsDraft": "Denne projektskabelon er en kladde",
  "templateName": "Skabelonnavn",
  "theProjectIsDone": "Projektet er færdigt",
  "timeConstraints": "Tidsbegrænsninger",
  "timeHHMM": "Tid (TT:MM)",
  "timePeriod": "Tidsperiode",
  "timestamp": "Tidsstempel",
  "timezone": "Tidszone",
  "to": "Til",
  "toConfirmDeletionType": "For at bekræfte sletning skriv {{keyword}}",
  "toConfirmDeletionTypeDeleteData": "For at bekræfte sletning skriv {{keyword}} og tryk bekræft. Dette sletter testdataene permanent, selv i simuleringstilstand. Det kan ikke fortrydes.",
  "toConfirmDeletionTypeKeyword": "For at bekræfte sletning skriv {{keyword}} og tryk bekræft",
  "toDate": "Til dato",
  "toDo": "At gøre",
  "toTime": "Til tid (TT:MM)",
  "toTimeHH": "Til tid (TT)",
  "toTimeHHMM": "Til tid (TT:MM)",
  "today": "I dag",
  "tokens": "Tokens",
  "total": "I alt",
  "normalSeats": "Normal",
  "tryReloadingOrContactSupport": "Prøv at genindlæse, eller kontakt support hvis problemet fortsætter!",
  "type": "Type",
  "typeBeforeConfirming": "skriv {{keyword}} før bekræftelse",
  "typeOrSelect": "Skriv eller vælg...",
  "typeYourMessage": "Skriv din besked...",
  "unassignedSamples": "Ikke-tildelte prøver",
  "unassignedSamplesFor": "Ikke-tildelte prøver for \"{{name}}\"",
  "unflag": "Fjern markering",
  "unflagSample": "Fjern markering af prøve",
  "unlockItemType": "Lås {{itemType}} op",
  "unlockSamples": "Lås prøver op",
  "unlocks": "Låser op",
  "unlocksAllFutureAnalysisTasks": "Låser alle fremtidige planlagte analyseopgaver op",
  "unlocksAllFutureProjectActions": "Låser alle fremtidige planlagte projekthandlinger op",
  "unnamed": "unavngivet",
  "unpinConversation": "Frigiv fastgjort samtale",
  "unplan": "Fjern fra plan",
  "unplanAnalysis": "Afplanlæg analyse",
  "unplanItemType": "Afplanlæg {{itemType}}",
  "unplanSample": "Afplanlæg prøve",
  "unplanSelected": "Afplanlæg valgte",
  "unplanned": "Ikke planlagt",
  "unplannedProjects": "Ikke-planlagte projekter",
  "unsavedChangesIn": "Der er ikke-gemte ændringer i:",
  "updateIntegration": "Opdater integration",
  "updatedIcalOutlook": "iCalendar / Outlook opdateret!",
  "uploadAborted": "Upload afbrudt!",
  "uploadComplete": "Upload fuldført!",
  "uploadFailedForFile": "Upload mislykkedes for fil: {{path}}",
  "uploadFinished": "Upload afsluttet!",
  "uploadTo": "Upload til {{name}}",
  "usage": "Forbrug",
  "used": "Brugt",
  "usedAssets": "Brugte instrumenter",
  "usedInstrument": "Brugt instrument",
  "usedInstruments": "Brugte instrumenter",
  "username": "Brugernavn",
  "value": "Værdi",
  "view": "Visning",
  "viewAllAnalysesForProduct": "Vis alle analyser for dette produkt",
  "viewAnalysisSamples": "Se analyseprøver",
  "viewCompact": "Kompakt visning",
  "viewNormal": "Normal visning",
  "weekNumber": "Uge {{week}}",
  "weekView": "Ugevisning",
  "dayView": "Dagsvisning",
  "weekendView": "Weekendvisning",
  "screen": "Skærm",
  "clickToSortBy": "Klik for at sortere efter {{column}}",
  "fileChangedPleaseReselect": "{{file}} er ændret. Vælg venligst filen igen",
  "contentTooWideZoomOut": "Indholdet er for bredt til skærmen. Zoom ud for en bedre visning ({{key}} +/-)",
  "week": "Uge",
  "weekly": "Ugentlig",
  "weeks": "uge(r)",
  "withConnections": "med forbindelser",
  "workHours": "Arbejdstimer",
  "workWeek": "Arbejdsuge",
  "years": "År",
  "yes": "Ja",
  "youAreInSimulationMode": "Du er i simuleringstilstand",
  "zeroHours": "0 timer",
  "addCustomer": "Tilføj kunde",
  "addGlobalChatbot": "Tilføj global chatbot",
  "addGlobalRepository": "Tilføj globalt repository",
  "apiKey": "API Key",
  "authenticationCode": "Godkendelseskode",
  "authenticationCodeSentInfo": "Vi har sendt en godkendelseskode til din e-mail. Indtast den ovenfor før login",
  "chatbotPrefix": "Chatbot-præfiks",
  "chatbotSystemPrompt": "Chatbot-systemprompt",
  "chatbotSystemPrompts": "Chatbot-systemprompter",
  "citationGuidelines": "Retningslinjer for citater",
  "configureMember": "Konfigurér medlem",
  "createApiKey": "Opret API key",
  "creatingProject": "Opretter projekt",
  "currentQuestion": "Nuværende spørgsmål",
  "customerAdminApiKeyForGlobalRepositories": "Kundeadmin API key til globale repositories",
  "dateFormatYyyyMmDd": "YYYY-MM-DD",
  "deleteApiKey": "Slet API key",
  "descriptionPrompt": "Beskrivelsesprompt",
  "editGlobalMessage": "Rediger global besked",
  "editingProject": "Redigerer projekt",
  "editSystemPrompts": "Rediger systemprompter",
  "filePathPrompt": "Filstiprompt",
  "fillingInSamples": "Udfylder prøver",
  "generalPrefix": "Generelt præfiks",
  "globalChatbots": "Globale chatbotter",
  "globalRepositories": "Globale repositories",
  "hideNextWeek": "Skjul næste uge",
  "hideSatSun": "- Lør/Søn",
  "manageAdmins": "Administrér administratorer",
  "oneWeek": "1 uge",
  "openMetricsPanel": "Åbn metrik-/IAP-panel",
  "openTodoList": "Åbn TODO-liste",
  "optimizedQuestionPrompt": "Optimeret spørgsmåls-prompt",
  "plannertech": "Plannertech",
  "plannertechSuite": "Plannertech Suite",
  "plannertechTeamPlan": "Plannertech Team Plan",
  "previousConversation": "Tidligere samtale",
  "librarianLogoAlt": "Librarian-logo",
  "qcLibrarianForCompany": "{{company}} QC Librarian",
  "relevantDocumentation": "Relevant dokumentation",
  "repositoryHasUnprocessedFilesInfo": "Der er ubehandlede filer i dette repository",
  "repositoryIsEmpty": "Dette repository er tomt",
  "repositoryPrefix": "Repository-præfiks",
  "repositoryProcessingInProgressInfo": "Repositoryet behandler i øjeblikket filerne. Opdatér siden for at se fremdriften",
  "sampleAllocation": "Prøveallokering",
  "mbWithValue": "{{value}} MB",
  "seatsWithCount": "Sæder: {{count}}",
  "excludingToday": "Ekskl. i dag",
  "unplanning": "Afplanlægger",
  "activeSeats": "Aktive sæder: {{count}}",
  "totalSeats": "Normale sæder: {{count}}",
  "purchasedSeats": "Købte sæder: {{count}}",
  "globalMessage": "Global besked",
  "clearGlobalMessageConfirm": "Er du sikker på, at du vil rydde den globale besked? Den forsvinder for alle brugere.",
  "samplesCount": "Prøver: {{count}}",
  "locations": "Lokationer",
  "customers": "Kunder",
  "editCustomer": "Rediger kunde",
  "addCustomerTitle": "Tilføj kunde",
  "deleteCustomer": "Slet kunde",
  "customerName": "Kundenavn",
  "customerStatus": "Kundestatus",
  "active": "Aktiv",
  "passive": "Passiv",
  "allowedDomains": "Tilladte domæner",
  "allowedPerformers": "Tilladte performers",
  "seatsPurchased": "Købte sæder",
  "customerApiKey": "Kunde-API-nøgle",
  "durationFormatDDHH": "DD:HH",
  "durationFormatHHMMSS": "HH:MM:SS",
  "durationFormatHHMM": "HH:MM",
  "durationFormatHH": "HH",
  "durationFormatDDHHMM": "DD:HH:MM",
  "continue": "Fortsæt",
  "showNextWeek": "Vis næste uge",
  "showSatSun": "+ Lør/Søn",
  "topDescriptionPrompt": "Top-beskrivelsesprompt",
  "twoWeeks": "2 uger",
  "updateHelpPage": "Opdater hjælpeside",
  "userAlreadyLoggedInTakeOver": "Bruger er allerede logget ind. Tryk bekræft for at overtage sessionen",
  "zoomIn": "Zoom ind",
  "zoomOut": "Zoom ud",
  "constraintWarningTitle": "{{count}} advarsel(er) er opstået",
  "assetStatusFree": "Ledig",
  "assetStatusBooked": "Booket",
  "dateTo": "til",
  "futureAnalysisTaskCantBeFinished": "En fremtidig analyseopgave kan ikke afsluttes",
  "tableNotFound": "Tabel ikke fundet",
  "conversionSheetFilename": "Conversion Sheet.xlsx",
  "selectTeam": "Select a team to log in to",
  "admin": "Admin",
  "customerAdmin": "Kundeadmin",
  "attachFile": "Vedhæft fil",
  "removeFile": "Fjern fil",
  "fileTooLarge": "Filen er for stor (maks 10 MB)",
  "tooManyFiles": "Maksimalt 3 filer pr. besked",
  "unsupportedFileType": "Filtypen understøttes ikke. Tilladt: PDF, DOCX, TXT, CSV, PNG, JPG, GIF, WEBP"
}
